export default __webpack_public_path__ + "static/media/ring_pushup.04587111.svg";